import { useState, useEffect, useRef } from 'react';

export function useTripMonitoring(booking, currentPosition, enabled = true) {
  const [durationOverrun, setDurationOverrun] = useState(0); // minutes over estimate
  const [routeDeviation, setRouteDeviation] = useState(false);
  const [checkInDue, setCheckInDue] = useState(false);
  const startTimeRef = useRef(null);
  const lastCheckInRef = useRef(Date.now());

  useEffect(() => {
    if (!enabled || !booking || booking.status !== 'in_progress') return;

    if (!startTimeRef.current) startTimeRef.current = Date.now();

    const interval = setInterval(() => {
      const elapsedMin = (Date.now() - startTimeRef.current) / 60000;
      const estimatedMin = booking.estimatedDuration || 30;
      const overrun = Math.max(0, elapsedMin - estimatedMin);
      setDurationOverrun(Math.round(overrun));

      // Check-in logic: 45min intervals (30min for night trips)
      const hour = new Date().getHours();
      const isNight = hour >= 22 || hour < 5;
      const checkInInterval = isNight ? 30 : 45;
      const sinceLastCheckIn = (Date.now() - lastCheckInRef.current) / 60000;
      setCheckInDue(sinceLastCheckIn >= checkInInterval);
    }, 30000); // Check every 30 seconds

    return () => clearInterval(interval);
  }, [enabled, booking]);

  const acknowledgeCheckIn = () => {
    lastCheckInRef.current = Date.now();
    setCheckInDue(false);
  };

  return { durationOverrun, routeDeviation, checkInDue, acknowledgeCheckIn };
}
